import pad from 'pad';

export function doublePad(num) {
  return pad(2, num.toString(), '0');
}

export function shuffleArray(array) {
  let i = array.length - 1;
  for (; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}


// WEBPACK FOOTER //
// ./src/util.js